function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import messages from '../messages';
import styles from '../RelatedData.pcss';
const Time = ({ timeSeriesResource })=>{
    const timestamp = timeSeriesResource.timestamp || timeSeriesResource.deviceDateTime || timeSeriesResource.dateTime;
    const time = moment.unix(timestamp).utc().format('LT');
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.relatedDataTooltip__detail,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.relatedDataTooltip__detailType,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.time))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.relatedDataTooltip__detailValue,
                children: time
            })
        ]
    });
};
export default Time;
